module.exports = __webpack_public_path__ + "1a01a556fad10ca04e333dc57e311feb.MP3";